module.exports = __webpack_public_path__ + "media/summer_2025_sweepstakes/member-8fd9745d.svg";